export const firebaseConfig = {
  apiKey: "AIzaSyCb2jYI-qNuoMhuQT8mbL2k-17TEWogb88",
  authDomain: "renpropapp.firebaseapp.com",
  projectId: "renpropapp",
  storageBucket: "renpropapp.firebasestorage.app",
  messagingSenderId: "572037413111",
  appId: "1:572037413111:web:e752e9e60e35200be87bf2",
  measurementId: "G-4E32RMPD99"
};